import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';

import { HttpClient, HttpHeaders } from '@angular/common/http';


declare const $: any;
declare interface RouteInfo {
    path: string;
    title: string;
    icon: string;
    class: string;
}



const httpOptions = {
  headers: new HttpHeaders(
    {
      'Content-Type': 'application/json',
    }
  )
};

/* ADMIN
export const ROUTES: RouteInfo[] = [
    { path: '/homecpnt/dashboard', title: 'Dashboard',  icon: 'dashboard', class: '' },
    { path: '/homecpnt/agence', title: 'Comparateur',  icon:'content_paste', class: '' },
    { path: '/homecpnt/sousreseau', title: 'Sous-Réseau',  icon:'person', class: '' },
    { path: '/homecpnt/versement', title: 'Versements',  icon:'content_paste', class: '' },
    { path: '/homecpnt/appeldefonds', title: 'Appel De Fonds',  icon:'content_paste', class: '' },
    { path: '/homecpnt/histotransact', title: 'Reporting',  icon:'library_books', class: '' },
    { path: '/homecpnt/partners', title: 'Partenaires',  icon: 'toc', class: '' },
    { path: '/homecpnt/packaging', title: 'Packaging',  icon:'view_column', class: '' },
    { path: '/homecpnt/comptafinances', title: 'Compta-Finances',  icon: 'money', class: '' },
    { path: '/homecpnt/avenants', title: 'Avenants',  icon:'settings', class: '' },
    { path: '/homecpnt/parametrage', title: 'Paramètrage',  icon:'settings', class: '' }
];
*/




@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  menuItems: any[];

  tampon = "" ;
  canOnlyPrepay = false ;

  constructor(private http: HttpClient, private router: Router) { 
  }

  ngOnInit() {

    let allRoutes  = JSON.parse(sessionStorage.getItem("yoonyifiam") );

    this.menuItems = allRoutes.filter(menuItem => menuItem);
  }


  isMobileMenu() {
      if ($(window).width() > 991) {
          return false;
      }
      return true;
  };


  isOnlyPrepaidAuthorized(compliances){
    let allOfThem = JSON.parse(compliances) ;
    this.canOnlyPrepay = false ;
    for (var i = 0; i < allOfThem.length; i++) {
        if(allOfThem[i].name=="solde_impaye")
            this.canOnlyPrepay = Number(allOfThem[i].valeur)<=0 ;
    }
  }


  disconnect(){
    this.tampon =sessionStorage.getItem("samacaabiyoonwii") ;  

    sessionStorage.clear();
    localStorage.clear();

    this. guennGueew() ;
    this.router.navigate(['/']) ;
  }

  guennGueew(){
    let logooutData = {samacaabiyoonwii: this.tampon} ;
    this.remotelogger('https://admindjolof.sentelecom.com/assurance/courtier/guenngueew.php', logooutData).subscribe(
        retourPost => {
          this.tampon = "" ;
    } ) ;
  }

  remotelogger(url: string, user: any) {
    return this.http.post(url, user, httpOptions);
  }


}
